<template>
  <nav
    v-if="!isDesktop"
    class="nav-wrapper"
    :class="{'onboarding': showOnboardingModal}"
  >
    <div class="list">
      <div
        v-for="tab in tabs"
        :key="tab.name"
        class="item"
        @click="selectThisTab(tab)"
      >
        <component
          :is="tab.icon"
          :class="['icon', activeTab === tab.name ? 'active' : 'inactive']"
        />
        <div :class="['label', activeTab === tab.name ? 'active' : 'inactive']">
          {{ tab.label }}
        </div>
      </div>
    </div>
  </nav>
  <section
    v-else
    class="header-nav"
  >
    <div class="container">
      <section class="logo-section">
        <img
          src="@vue3/assets/images/sahabatomg-dark-logo.png"
          alt="ikon"
        >
      </section>
      <section class="list">
        <div
          v-for="tab in tabs"
          :key="tab.name"
          class="item"
          @click="selectThisTab(tab)"
        >
          <div :class="['label', activeTab === tab.name ? 'active' : 'inactive']">
            {{ tab.label }}
          </div>
        </div>
      </section>
      <div class="icon-container">
        <div
          v-if="isNotificationPermissionGranted"
          class="icon-container-wrapper"
        >
          <BliIconSiNotification
            class="navigation-icon"
            @click.native="toggleNotificationModal"
          />
          <BliBadge
            v-if="getUnreadNotificationCount"
            notification
            class="notification-badge"
          >
            {{ getUnreadNotificationCount }}
          </BliBadge>
        </div>
        <BliIconSiSetting
          class="navigation-icon"
          @click.native="handleSettingsClick"
        />
      </div>
      <NotificationModal
        :is-modal-visible="showNotificationModal && isDesktop"
        @closeModal="toggleNotificationModal"
      />
    </div>
  </section>
</template>
<script src="./index.js" />
<style lang="scss" scoped>
@import "@vue3/assets/styles/_responsive.scss";
html:not([dark]) {
  @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
  @import './index.scss';
}
html[dark] {
  @import '@blibli/blue-design-tokens/dist/tokens-dark.scss';
  @import './index.scss';
}
</style>
